import { Link } from "wouter";
import logo from "../assets/icons/outclose_horizontal.svg";
import icon from "../assets/icons/outclose.svg";

interface LogoProps {
  className?: string;
  link?: string;
  asChild?: boolean;
  /** Show the standalone icon next to the wordmark. */
  withIcon?: boolean;
  /** Stack the icon on top of the wordmark instead of beside it. Implies withIcon. */
  iconOnTop?: boolean;
}

export default function Logo({ className, link, withIcon, iconOnTop }: LogoProps) {
  const showIcon = withIcon || iconOnTop;
  return (
    <Link
      href={link || "/"}
      className={`flex ${iconOnTop ? "flex-col" : "items-center"} gap-2 group cursor-pointer font-Poppins ${className}`}
    >
      {showIcon && (
        <img src={icon} alt="" aria-hidden className={`w-auto ${iconOnTop ? "h-10" : "h-7"} dark:invert`} />
      )}
      <img src={logo} alt="Outclose" className="w-auto h-6 dark:invert" />
    </Link>
  );
}

